<template>
  <button
    type="button"
    class="lu-button lu-button--ghost lu-language"
    :aria-label="ariaLabel"
    :title="ariaLabel"
    @click="switchLocale"
  >
    <UiIcon name="globe" />
    <span :lang="targetLocale">{{ targetLabel }}</span>
  </button>
</template>
<script>
import UiIcon from '../ui/UiIcon.vue';
import { changeLanguage } from '../../plugins/locale';

export default {
  name: 'LanguageSwitcher',
  components: { UiIcon },
  computed: {
    // Visible label = language you switch TO (not the current locale).
    targetLocale() { return this.$i18n.locale === 'ar' ? 'en' : 'ar'; },
    targetLabel() { return this.targetLocale === 'ar' ? 'العربية' : 'English'; },
    ariaLabel() {
      return this.$t('ui.switchToLanguage', { language: this.targetLabel });
    },
  },
  methods: {
    switchLocale() { changeLanguage(this.$i18n, this.targetLocale); },
  },
};
</script>
